import React, { useEffect } from 'react';
import { useAuthModal } from '../../contexts/AuthModalContext';
import './Login.css';

/**
 * Guest (or disabled) hitting a role hub — stay on the URL, open AuthModal.
 */
const ProtectedAuthGate = ({ disabled = false }) => {
  const { openAuthModal } = useAuthModal();

  useEffect(() => {
    openAuthModal({ mode: 'signin' });
  }, [openAuthModal]);

  return (
    <div className="protected-auth-gate">
      <div className="protected-auth-gate__panel">
        <p className="protected-auth-gate__eyebrow">MapToBe</p>
        <h1 className="protected-auth-gate__title">
          {disabled ? 'Account disabled' : 'Sign in to continue'}
        </h1>
        <p className="protected-auth-gate__lede">
          {disabled
            ? 'This account is suspended. Ask an admin to Enable it in Users, then sign in again.'
            : 'This area is for signed-in staff. Create an account or sign in to keep going.'}
        </p>
        <button
          type="button"
          className="login-submit-btn"
          onClick={() => openAuthModal({ mode: 'signin' })}
        >
          Sign in
        </button>
      </div>
    </div>
  );
};

export default ProtectedAuthGate;
